import qs from 'qs';
import Vue from 'vue';
import axios from "axios";
import store from '../store/index.js';
import router from '../router/index'
import {
  Loading,Message 
} from 'element-ui';
//配置请求根路径
const UPLOAD_URL = {
  // dev: "/api",
  //dev:'http://clssh.ichenglan.com:30106/api',
  dev:'http://www.ichenglan.com:36005',
  // dev:'http://127.0.0.1:36005',
  prod:'/api/',
  // test: "/test",
  test:'http://8.133.173.169:8080'
}
// axios.defaults.baseURL = process.env.NODE_ENV === 'production' ? UPLOAD_URL.prod : UPLOAD_URL.test;
axios.defaults.baseURL = process.env.NODE_ENV === 'production' ? UPLOAD_URL.prod : UPLOAD_URL.dev;


export const apiUrl = axios.defaults.baseURL
export const serverUrl = UPLOAD_URL.prod
axios.defaults.transformResponse = [function(data) {
  // `transformResponse` 在传递给 then/catch 前，允许修改响应数据
  if (typeof data === 'string') {
    try {
      data = Vue.prototype.$JsonBigInt.parse(data)
    } catch (e) {
      console.log(e);
    }
  }
  return data
}]
//在挂载到原型对象前先设置一个request请求拦截器，使用use挂载一个回调函数
//config就是请求对象
//请求到达服务器之前先调用这个回调函数，对headers做预处理
axios.interceptors.request.use(config => {
  config.headers['content-type'] = 'application/json';
  config.headers.Authorization = window.localStorage.getItem("token");
  return config;
});
axios.interceptors.response.use(result => {
  if (result.data && result.data.code == 401) {
    return router.replace('/login?cbUrl=' + encodeURIComponent(router.fullPath))
  }
  return result;
}, (err) =>{
  if (err.response && err.response.status === 401) {
    return router.replace('/login?cbUrl=' + encodeURIComponent(router.fullPath))
  }
  return Promise.reject(err);
});

export default axios